<template>
  <div class="addressBox" >
    <el-form-item label="承运商:" prop="generalCarrier" class="width1" :rules="[{ required: true, message: '请选择承运商', trigger: 'blur' }]" >
      <el-select  v-model="goodform.generalCarrier" filterable placeholder="请选择" clearable   @change="generalCarrierChange">
        <el-option v-for="item in CYSList" :label="item.customerName" :value="item.customerName" :key="item.id"></el-option>
      </el-select>
    </el-form-item>
     <el-form-item label="推送网货:" prop="onlineFreightFlag" v-if="goodform.onlineFlag==1&&goodform.generalCarrier">
        <span>{{goodform.onlineFreightFlag==1?'是':'否'}}</span>
      </el-form-item>
     <el-form-item label="服务费计算:" prop="reverseCountFlag" v-if="goodform.generalCarrier"  label-width="110px">
      <el-radio-group v-model="goodform.reverseCountFlag">
        <el-radio label="1">反算</el-radio>
        <el-radio label="0">正算</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item label="需求车长:"   >
      <el-select  v-model="goodform.needLength" filterable placeholder="请选择">
        <el-option v-for="item in CClist" :label="item.name+'米'" :value="item.name+'米'" :key="item.id"></el-option>
      </el-select>
    </el-form-item>
    <span class="red" v-if="goodform.WHJKflag">司机车辆需先在网货平台注册才可指派</span>
    <div  v-if="goodform.WHJKflag">
      <el-table :data="[{}]"  ref="table"  bordersize="mini" class="tableBox" style="" max-height="500px"  center border>
        <el-table-column label="操作"  width="100">
          <template slot-scope="scope">
            <div>
              <el-button type="text" size="mini" @click="sijiFn">司机</el-button>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="车牌号" min-width="120">
          <template slot="header" >
            <div><span class="red">*</span>车牌号</div>
          </template>
          <template >
            <div>
              <el-form-item label=""   class="table_error" >
                {{goodform.plateNumber}}
              </el-form-item>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="车牌颜色" min-width="120">
          <template >
            <div>
              <el-form-item label=""    class="table_error" >
                {{goodform.licensePlateColorName}}
              </el-form-item>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="能源类型" min-width="120">
          <template >
            <div>
              <el-form-item label=""    class="table_error" >
                {{goodform.energyTypeName}}
              </el-form-item>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="司机" min-width="120">
          <template slot="header" >
            <div><span class="red">*</span>司机</div>
          </template>
          <template >
            <div>
              <el-form-item label=""   class="table_error" >
                {{goodform.driverName}}
              </el-form-item>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="联系电话" min-width="120">
          <template slot="header" >
            <div><span class="red">*</span>联系电话</div>
          </template>
          <template >
            <div>
              <el-form-item label=""  class="table_error"  >
                {{goodform.driverPhone}}
              </el-form-item>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="身份证号" min-width="120">
          <template >
            <div>
              <el-form-item label=""  class="table_error"  >
                {{goodform.idNumber}}
              </el-form-item>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div v-else>
      <el-table :data="[{}]" v-if="goodform.transportMode==1"  ref="table"  bordersize="mini" class="tableBox" style="" max-height="500px"  center border>
          <el-table-column label="车牌号" min-width="120">
              <template slot="header" >
                <div><span class="red">*</span>车牌号</div>
              </template>
              <template >
                <div style="display:flex;align-items: center;">
                  <el-form-item label=""   class="table_error" >
                    <el-autocomplete class="inline-input" v-model.trim="goodform.plateNumber" :popper-append-to-body="false"
                        :fetch-suggestions="searchFn1" value-key="id" @select="dbSelected1" @blur="carBlurFn" popper-class="xiala">
                          <template slot-scope="{ item }">
                              <div style="position: relative;">
                              <div class="name">{{ item.vhcNo }} / {{ [ "外协", "自有" ][item.vhcClassify-1]}}</div>
                            </div>
                        </template>
                    </el-autocomplete>
                  </el-form-item>
                  <i  class="el-icon-circle-plus-outline el-input__icon"  slot="suffix"  @click="addVL">  </i>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="车牌颜色" min-width="120">
              <template >
                <div>
                  <el-form-item label=""    class="table_error" >
                    {{goodform.licensePlateColorName}}
                    <!-- <el-select  v-model="goodform.licensePlateColor" filterable placeholder="请选择">
                      <el-option v-for="item in clys" :key="item.value" :label="item.label"  :value="item.value"  ></el-option>
                    </el-select> -->
                  </el-form-item>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="能源类型" min-width="120">
              <template >
                <div>
                  <el-form-item label=""    class="table_error" >
                    {{goodform.energyTypeName}}
                  </el-form-item>
                </div>
              </template>
            </el-table-column>
          <el-table-column label="车长" min-width="120">
            <template >
              <div>
                <el-form-item label=""   class="table_error" >
                <el-select placeholder="请选择" filterable v-model="goodform.vehicleLength">
                  <el-option v-for="(item,index) in vhcLongList" :key="index" :label="item.longName" :value="item.longName"></el-option>
                </el-select>
                </el-form-item>
              </div>
            </template>
          </el-table-column>
            <el-table-column label="司机" min-width="120">
              <template slot="header" >
                <div><span class="red">*</span>司机</div>
              </template>
              <template >
                <div style="display:flex;align-items: center;">
                  <el-form-item label=""   class="table_error" >
                  <el-autocomplete class="inline-input" v-model.trim="goodform.driverName" :popper-append-to-body="false"
                      :fetch-suggestions="searchFn2" value-key="id" @select="dbSelected2" @blur="sijiBlurFn" popper-class="xiala">
                        <template slot-scope="{ item }">
                            <div style="position: relative;">
                            <div class="name">{{ item.name }} / {{ [ "外协", "自有" ][item.driverClassify-1]}}{{item.mobile}}</div>
                          </div>
                      </template>
                  </el-autocomplete>
                  </el-form-item>
                  <i  class="el-icon-circle-plus-outline el-input__icon"  slot="suffix"  @click="addsiji">  </i>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="联系电话" min-width="120">
              <template slot="header" >
                <div>联系电话</div>
              </template>
              <template >
                <div>
                  <el-form-item label=""  class="table_error"  >
                    {{goodform.driverPhone}}
                    <!-- <el-input  placeholder=""    maxlength="12" v-model="goodform.driverPhone"  ></el-input> -->
                  </el-form-item>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="身份证号" min-width="120">
              <template >
                <div>
                  <el-form-item label=""  class="table_error"  >
                    {{goodform.idNumber}}
                    <!-- <el-input  placeholder=""    maxlength="12" v-model="goodform.idNumber"  ></el-input> -->
                  </el-form-item>
                </div>
              </template>
            </el-table-column>
      </el-table>
      <el-form-item label="船舶名称:"  v-if="goodform.transportMode==2" prop="plateNumber" class="width1"  :rules="[{ required: true, message: '请选择船舶', trigger: 'blur' }]" >
          <el-select  v-model="goodform.plateNumber" filterable placeholder="请选择" clearable   @change="chuanboChange">
            <el-option v-for="item in chuanboList" :label="item.shipName" :value="item.shipName" :key="item.id"></el-option>
          </el-select>
        </el-form-item>
    </div>
    <addDriver v-if="addDriverFlag" :addDriverFlag.sync='addDriverFlag' @cDaddFn="dbSelected2"></addDriver>
    <addVehicle v-if="addVehicleFlag" :addVehicleFlag.sync='addVehicleFlag' @cVIaddFn="dbSelected1"></addVehicle>
    <WHxuansiji v-if="WHxuansijiFlag" :WHxuansijiFlag.sync='WHxuansijiFlag' @selectCar="selectCar"></WHxuansiji>
  </div>
</template>

<script>
import { getDictionaryDetailList, cDlist, cVIlist, findCustomerInfoList, getWayForPlateNumber, getCustomerTaxRate, pushWayToWHPTFlag, findDriverInfoById, shipList } from '@/api/newTMS'
import { selectTMSTenantListByCustom, listVehicleLengthsByModelId } from '@/api/newCrm'
import { cVLlist } from '@/api/vgs-driver2.0'
import addDriver from '@/views/newTMS/publicFiles/wayAndOrder/addDriver.vue'
import addVehicle from '@/views/newTMS/publicFiles/wayAndOrder/addVehicle.vue'
import WHxuansiji from '@/views/newTMS/publicFiles/wayAndOrder/WHxuansiji.vue'
export default {
  name: 'shouru',
  components: {
    addDriver, addVehicle, WHxuansiji
  },
  props: {
    goodform: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      CPYSlist: [],
      NYLXlist: [],
      cysList: [],
      CYSList: [],
      XZCLflag: false,
      searchFrom1: {
        pageNo: 1,
        pageSize: 1000
      },
      total2: 0,
      XZSJflag: false,
      searchFrom2: {
        pageNo: 1,
        pageSize: 1000
      },
      addDriverFlag: false,
      addVehicleFlag: false,
      WHxuansijiFlag: false,
      isWuxian: null,
      fuwufeilv: null,
      gongzishuilv: null,
      CClist: [],
      chuanboList: [],
      vhcLongList: []
    }
  },
  mounted: function () { // 在更新DOM之前 调用此钩子函数 应用：可以获取原始的DOM
    // 默认为自有
    if (!this.goodform.driverOwnership && this.goodform.driverOwnership !== 0) {
      this.$set(this.goodform, 'driverOwnership', 0)
      this.$set(this.goodform, 'driverOwnershipName', '自有')
    }
    if (!this.goodform.vehicleOwnership && this.goodform.vehicleOwnership !== 0) {
      this.$set(this.goodform, 'vehicleOwnership', 0)
      this.$set(this.goodform, 'vehicleOwnershipName', '自有')
    }
    shipList().then(res => { this.chuanboList = res })
    getDictionaryDetailList({ dictionaryType: 'energy_type' }).then(res => { this.NYLXlist = res })
    getDictionaryDetailList({ dictionaryType: 'colour_type' }).then(res => { this.CPYSlist = res })
    cVLlist().then(res => { this.CClist = res })
    findCustomerInfoList({ businessType: 2 }).then(res => {
      selectTMSTenantListByCustom(res).then(res1 => {
        this.CYSList = res1
        if (this.goodform.generalCarrier) {
          let json = this.CYSList.filter(item => item.customerName == this.goodform.generalCarrier)
          if (json.length > 0) {
            this.$set(this.goodform, 'onlineFlag', json[0].onlineFlag)
          } else {
            this.$set(this.goodform, 'onlineFlag', null)
          }
        }
      })
    })
    listVehicleLengthsByModelId({ modelId: 99999 }).then(res => {
      this.vhcLongList = res
    })
  },
  methods: {
    // 选择船舶
    chuanboChange () {
      let json = this.chuanboList.filter(item => item.shipName == this.goodform.plateNumber)
      this.$set(this.goodform, 'vehicleId', json[0].id)
    },
    carBlurFn () {
      if (!this.goodform.vehicleId) {
        this.$set(this.goodform, 'plateNumber', '')
      }
    },
    sijiBlurFn () {
      if (!this.goodform.driverId) {
        this.$set(this.goodform, 'driverName', '')
      }
    },
    // 网货选司机
    sijiFn () {
      this.WHxuansijiFlag = true
    },
    selectCar (row) {
      this.$set(this.goodform, 'vehicleId', '')
      this.$set(this.goodform, 'plateNumber', row.vhcNo)
      this.$set(this.goodform, 'licensePlateColor', row.noColourCode)
      this.$set(this.goodform, 'licensePlateColorName', row.noColourName)
      this.$set(this.goodform, 'vehicleType', '')
      this.$set(this.goodform, 'vehicleTypeName', row.vhcTypeName)
      this.$set(this.goodform, 'energyType', '')
      this.$set(this.goodform, 'energyTypeName', row.energyName)
      this.$set(this.goodform, 'vehicleOwnership', 1)
      this.$set(this.goodform, 'vehicleOwnershipName', '外协')
      this.$set(this.goodform, 'vehicleLength', row.vhcLength)

      this.$set(this.goodform, 'driverId', '')
      this.$set(this.goodform, 'driverName', row.name)
      this.$set(this.goodform, 'driverPhone', row.mobile)
      this.$set(this.goodform, 'idNumber', row.identityNo)
      this.$set(this.goodform, 'driverOwnership', 1)
      this.$set(this.goodform, 'driverOwnershipName', '外协')
    },
    // 承运商改变
    generalCarrierChange (e) {
      if (e) {
        let json = this.CYSList.filter(item => item.customerName == this.goodform.generalCarrier)
        this.goodform.generalTaxId = json[0].customerTaxId
        this.goodform.generalCode = json[0].tenantCode
        this.goodform.generalPeriodDays = json[0].periodDays
        this.goodform.generalInvoiceDays = json[0].invoiceDays
        this.goodform.generalPeriodDaysType = json[0].periodDaysType
        this.$set(this.goodform, 'payer', this.goodform.generalCarrier)
        this.$set(this.goodform, 'payerTaxId', json[0].customerTaxId)
        this.$set(this.goodform, 'payerCode', json[0].tenantCode)
        this.$set(this.goodform, 'collectionType', 1)

        this.$set(this.goodform, 'expenditurePattern', json[0].settlementType)
        this.$set(this.goodform, 'expenditurePatternName', json[0].settlementTypeName)
        // this.$set(this.goodform, 'vehicleId', '')
        // this.$set(this.goodform, 'plateNumber', '')
        // this.$set(this.goodform, 'licensePlateColor', '')
        // this.$set(this.goodform, 'licensePlateColorName', '')
        // this.$set(this.goodform, 'vehicleType', '')
        // this.$set(this.goodform, 'vehicleTypeName', '')
        // this.$set(this.goodform, 'energyType', '')
        // this.$set(this.goodform, 'energyTypeName', '')
        // this.$set(this.goodform, 'vehicleOwnership', '')
        // this.$set(this.goodform, 'vehicleOwnershipName', '')
        // this.$set(this.goodform, 'driverId', '')
        // this.$set(this.goodform, 'driverName', '')
        // this.$set(this.goodform, 'driverPhone', '')
        // this.$set(this.goodform, 'idNumber', '')
        // this.$set(this.goodform, 'driverOwnership', '')
        // this.$set(this.goodform, 'driverOwnershipName', '')
        // this.$set(this.goodform, 'onlineFreightFlag', json[0].onlineFreightFlag)
        this.$set(this.goodform, 'onlineFlag', json[0].onlineFlag)
        this.$set(this.goodform, 'reverseCountFlag', json[0].reverseCountFlag)
        this.$set(this.goodform, 'WHJKflag', false)
        // this.$set(this.goodform, 'serviceRate', json[0].serviceRate)
        this.gongzishuilv = json[0].payrollTaxPoint
        this.fuwufeilv = json[0].serviceRate
        if (this.isWuxian == null && this.goodform.driverId) { // 如果是回显过来没有值。所以走一遍接口
          findDriverInfoById({ id: this.goodform.driverId }).then(res => {
            this.isWuxian = res.fiveInsurances == '1'
            this.$set(this.goodform, 'serviceRate', this.isWuxian ? this.gongzishuilv : this.fuwufeilv)
          })
        } else {
          this.$set(this.goodform, 'serviceRate', this.isWuxian ? this.gongzishuilv : this.fuwufeilv)
        }
        this.$set(this.goodform, 'freightTaxRate', json[0].taxRate)
      } else {
        // this.$set(this.goodform, 'onlineFreightFlag', null)
        this.$set(this.goodform, 'onlineFlag', null)
        this.$set(this.goodform, 'reverseCountFlag', null)
        this.$set(this.goodform, 'serviceRate', 0)
        this.goodform.generalTaxId = null
        this.goodform.generalCode = null
        this.goodform.generalPeriodDays = null
        this.$set(this.goodform, 'payer', null)
        this.$set(this.goodform, 'payerTaxId', null)
        this.$set(this.goodform, 'payerCode', null)
        this.goodform.generalPeriodDaysType = ''
        this.$set(this.goodform, 'WHJKflag', false)
      }
    },
    // 运力改变
    yunliChange (e) {
      this.$set(this.goodform, 'generalCarrier', '')
      this.$set(this.goodform, 'generalTaxId', '')
      this.$set(this.goodform, 'plateNumber', '')
      this.$set(this.goodform, 'licensePlateColor', '')
      this.$set(this.goodform, 'licensePlateColorName', '')
      this.$set(this.goodform, 'vehicleType', '')
      this.$set(this.goodform, 'vehicleTypeName', '')
      this.$set(this.goodform, 'energyType', '')
      this.$set(this.goodform, 'energyTypeName', '')
      this.$set(this.goodform, 'vehicleOwnership', '')
      this.$set(this.goodform, 'vehicleOwnershipName', '')
      this.$set(this.goodform, 'vehicleLength', '')
      this.$set(this.goodform, 'driverId', '')
      this.$set(this.goodform, 'driverName', '')
      this.$set(this.goodform, 'driverPhone', '')
      this.$set(this.goodform, 'idNumber', '')
      this.$set(this.goodform, 'vehicleId', '')
      this.$set(this.goodform, 'driverOwnership', '')
      this.$set(this.goodform, 'driverOwnershipName', '')
      if (e == 1) { // 外协
        this.$set(this.goodform, 'payer', '')
        this.$set(this.goodform, 'payerTaxId', '')
        this.$set(this.goodform, 'driverOwnership', 1)
        this.$set(this.goodform, 'driverOwnershipName', '外协')
        this.$set(this.goodform, 'vehicleOwnership', 1)
        this.$set(this.goodform, 'vehicleOwnershipName', '外协')
      } else { // 自有0
        this.$set(this.goodform, 'payer', '唐山薪伙伴科技有限公司')
        this.$set(this.goodform, 'payerTaxId', '91130230MA7L1EB616')
        this.$set(this.goodform, 'driverOwnership', 0)
        this.$set(this.goodform, 'driverOwnershipName', '自有')
        this.$set(this.goodform, 'vehicleOwnership', 0)
        this.$set(this.goodform, 'vehicleOwnershipName', '自有')
      }
      this.tableList1 = []
      this.tableList2 = []
      this.total1 = 0
      this.total2 = 0
    },
    addVL () {
      this.addVehicleFlag = true
    },
    addsiji () {
      this.addDriverFlag = true
    },
    dbSelected1 (row) {
      this.$set(this.goodform, 'vehicleId', row.id)
      this.$set(this.goodform, 'licensePlateColorName', row.noColourName)
      this.$set(this.goodform, 'plateNumber', row.vhcNo)
      this.$set(this.goodform, 'licensePlateColor', row.noColourCode)
      this.$set(this.goodform, 'vehicleType', row.vhcTypeId)
      this.$set(this.goodform, 'vehicleTypeName', row.vhcTypeName)
      this.$set(this.goodform, 'energyType', row.energyId)
      this.$set(this.goodform, 'energyTypeName', row.energyName)
      this.$set(this.goodform, 'vehicleOwnership', row.vhcClassify == 2 ? 0 : row.vhcClassify)
      this.$set(this.goodform, 'vehicleOwnershipName', [ '外协', '自有' ][row.vhcClassify - 1])
      this.$set(this.goodform, 'vehicleLength', row.vhcLength)
      getWayForPlateNumber({
        pageNo: 1,
        pageSize: 1,
        plateNumber: row.vhcNo
      }).then(res => {
        if (res.list.length > 0) {
          if (res.list[0].driverId && res.list[0].vehicleId) {
            let json = res.map.driverInfo
            this.$set(this.goodform, 'driverId', res.list[0].driverId)
            this.$set(this.goodform, 'driverName', json.name)
            this.$set(this.goodform, 'driverPhone', json.mobile)
            this.$set(this.goodform, 'idNumber', json.identityNo)
            this.$set(this.goodform, 'driverOwnership', res.map.driverClassify == 2 ? 0 : res.map.driverClassify)
            this.$set(this.goodform, 'driverOwnershipName', [ '外协', '自有' ][res.map.driverClassify - 1])
            if (this.goodform.collectionType == 2) {
              this.$set(this.goodform, 'payer', json.name)
              this.$set(this.goodform, 'payerTaxId', json.idNumber)
            }
            // 根据司机获取承运商逻辑
            if (!this.goodform.generalCarrier) {
              findDriverInfoById({ id: res.list[0].driverId }).then(res => {
                this.isWuxian = res.fiveInsurances == '1'
                if (res.ext1) {
                  this.$set(this.goodform, 'generalCarrier', res.ext1)
                  this.generalCarrierChange(res.ext1)
                }
                // 获取司机的小队公司信息
                this.$set(this.goodform, 'teamOrgId', res.teamOrgId)
                this.$set(this.goodform, 'teamOrgCode', res.teamOrgCode)
                this.$set(this.goodform, 'teamOrgName', res.teamOrgName)
                this.$set(this.goodform, 'companyOrgId', res.companyOrgId)
                this.$set(this.goodform, 'companyOrgCode', res.companyOrgCode)
                this.$set(this.goodform, 'companyOrgName', res.companyOrgName)
              })
            } else { // 司机工资五险逻辑
              if ((this.gongzishuilv == null || this.fuwufeilv == null) && this.goodform.generalCarrier) { // 没有服务费率先获取一下
                let json = this.CYSList.filter(item => item.customerName == this.goodform.generalCarrier)
                this.gongzishuilv = json[0].payrollTaxPoint
                this.fuwufeilv = json[0].serviceRate
              }
              findDriverInfoById({ id: res.list[0].driverId }).then(res => {
                this.isWuxian = res.fiveInsurances == '1'
                this.$set(this.goodform, 'serviceRate', this.isWuxian ? this.gongzishuilv : this.fuwufeilv)
                // 获取司机的小队公司信息
                this.$set(this.goodform, 'teamOrgId', res.teamOrgId)
                this.$set(this.goodform, 'teamOrgCode', res.teamOrgCode)
                this.$set(this.goodform, 'teamOrgName', res.teamOrgName)
                this.$set(this.goodform, 'companyOrgId', res.companyOrgId)
                this.$set(this.goodform, 'companyOrgCode', res.companyOrgCode)
                this.$set(this.goodform, 'companyOrgName', res.companyOrgName)
              })
            }
          }
        } else {
          this.$set(this.goodform, 'driverId', '')
          this.$set(this.goodform, 'driverName', '')
          this.$set(this.goodform, 'driverPhone', '')
          this.$set(this.goodform, 'idNumber', '')
          this.$set(this.goodform, 'driverOwnership', '')
          this.$set(this.goodform, 'driverOwnershipName', '')
        }
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
          }
        })
      })
    },
    dbSelected2 (row) {
      this.$set(this.goodform, 'driverId', row.id)
      this.$set(this.goodform, 'driverName', row.name)
      this.$set(this.goodform, 'driverPhone', row.mobile)
      this.$set(this.goodform, 'idNumber', row.identityNo)
      this.$set(this.goodform, 'driverOwnership', row.driverClassify == 2 ? 0 : row.driverClassify)
      this.$set(this.goodform, 'driverOwnershipName', [ '外协', '自有' ][row.driverClassify - 1])
      if (this.goodform.collectionType == 2) {
        this.$set(this.goodform, 'payer', row.name)
        this.$set(this.goodform, 'payerTaxId', row.identityNo)
      }
      // 获取司机的小队公司信息
      this.$set(this.goodform, 'teamOrgId', row.teamOrgId)
      this.$set(this.goodform, 'teamOrgCode', row.teamOrgCode)
      this.$set(this.goodform, 'teamOrgName', row.teamOrgName)
      this.$set(this.goodform, 'companyOrgId', row.companyOrgId)
      this.$set(this.goodform, 'companyOrgCode', row.companyOrgCode)
      this.$set(this.goodform, 'companyOrgName', row.companyOrgName)
      // 根据司机获取承运商逻辑
      if (!this.goodform.generalCarrier) {
        this.isWuxian = row.fiveInsurances == 1
        if (row.ext1) {
          this.$set(this.goodform, 'generalCarrier', row.ext1)
          this.generalCarrierChange(row.ext1)
        }
      } else { // 司机工资五险逻辑
        if ((this.gongzishuilv == null || this.fuwufeilv == null) && this.goodform.generalCarrier) { // 没有服务费率先获取一下
          let json = this.CYSList.filter(item => item.customerName == this.goodform.generalCarrier)
          this.gongzishuilv = json[0].payrollTaxPoint
          this.fuwufeilv = json[0].serviceRate
        }
        this.isWuxian = row.fiveInsurances == 1
        this.$set(this.goodform, 'serviceRate', this.isWuxian ? this.gongzishuilv : this.fuwufeilv)
      }
    },
    searchFn1 (str, cb) {
      this.$set(this.goodform, 'vehicleId', '')
      this.$set(this.goodform, 'licensePlateColor', '')
      this.$set(this.goodform, 'licensePlateColorName', '')
      this.$set(this.goodform, 'vehicleType', '')
      this.$set(this.goodform, 'vehicleTypeName', '')
      this.$set(this.goodform, 'energyType', '')
      this.$set(this.goodform, 'energyTypeName', '')
      this.$set(this.goodform, 'vehicleOwnership', '')
      this.$set(this.goodform, 'vehicleOwnershipName', '')
      this.$set(this.goodform, 'vehicleLength', '')
      this.searchFrom1.vhcNoLike = str
      // if (this.goodform.generalCarrier) {
      //   this.searchFrom1.vhcClassify = 1
      // } else {
      //   this.searchFrom1.vhcClassify = ''
      // }
      cVIlist(this.searchFrom1).then(res => {
        cb(res.list)
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
          }
        })
      })
    },
    searchFn2 (str, cb) {
      this.$set(this.goodform, 'driverId', '')
      this.$set(this.goodform, 'driverPhone', '')
      this.$set(this.goodform, 'idNumber', '')
      this.$set(this.goodform, 'driverOwnership', '')
      this.$set(this.goodform, 'driverOwnershipName', '')
      this.searchFrom2.name = str
      // if (this.goodform.generalCarrier) {
      //   this.searchFrom2.driverClassify = 1
      // } else {
      //   this.searchFrom2.driverClassify = ''
      // }
      cDlist(this.searchFrom2).then(res => {
        cb(res.list)
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
          }
        })
      })
    }
  }

}
</script>

<style scoped lang='less'>
.width2 /deep/.el-input__inner{
  width: 100px;
}
/deep/.el-autocomplete-suggestion li{
  padding: 0 10px;
  overflow: auto;
  text-align: left;
}
/deep/.xiala{
  width: 240px!important;
}
/deep/.el-icon-circle-plus-outline{
  font-size: 20px;
  margin-left:6px ;
  color: #bfc0c3;
}
/deep/.tableBox .el-input__inner{
    width: 110px!important;
}
/deep/.tableBox .el-select.el-input__inner{
    width: 260px!important;
}
</style>
